/**
* We'll load the axios HTTP library which allows us to easily issue requests
* to our Laravel back-end. This library automatically handles sending the
* CSRF token as a header based on the value of the "XSRF" token cookie.
*/
require("../../utils/connection.js");
import Store from "../store/store"
import { showDefaultErrorMessages } from "@/utils/RequestErrors"
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use(
  response=>response,
  error => {
    if (error.response && error.response.data.message == "Inactivated") {
      Store.commit("SET_USER_DESACTIVATED")
    }else if (error.response && (error.response.status == 419 || (error.response.status == 401 && error.response.data.message == "Unauthenticated."))) {
      Store.commit("SET_SESSION_EXPIRED")
    }else {
      showDefaultErrorMessages(error)
    }
    return Promise.reject(error);
  }
);
 